<template>
  <Organisation title="Users | Organisation Settings">
    <div class="container">
      <div class="row">
        <h3 class="col-md-6">
          Users
          <inertia-link class="btn btn-primary text-white ml-4" :href="route('organisation.user.create', organisation.id)">Add new user</inertia-link>
        </h3>
        <div class="col-md-3 ml-auto">
          <InlineSearch v-model="searchQuery" />
        </div>
      </div>
    </div>

    <div class="container mt-4">
      <div class="row">
        <div class="col">
          <table class="table">
            <thead>
              <tr>
                <th
                  v-for="(key, index) in columns"
                  :key="index"
                  @click="sortBy(key.column)"
                  class="text-left pt-4 pb-4"
                  :class="{ active: sortKey == key.column }"
                >
                  {{ key.title }}
                  <i v-if="sortOrders[key.column] > 0" class="fas fa-caret-up" />
                  <i v-else class="fas fa-caret-down" />
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <User
                v-for="user in filteredUsers"
                :key="user.id"
                :user="user"
                :organisation-id="organisation.id"
                v-on:show="userDeleted"
              />
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="container mt-5">
      <div class="row justify-content-center">
        <div class="col-md-3">
          <LoadingButton
            v-if="showLoadMore"
            @click.native="loadMore"
            :loading="loading"
            class="btn btn-primary btn-block"
          >Load More</LoadingButton>
        </div>
      </div>

    </div>
  </Organisation>
</template>

<script>
import Organisation from '@/Pages/Account/Organisation/Organisation';
// import Pagination from '@/Shared/Pagination.vue';
import InlineSearch from '@/Shared/InlineSearch.vue';
import User from '@/Pages/Account/Organisation/Users/Show';
import LoadingButton from '@/Shared/LoadingButton';

export default {
  components: {
    LoadingButton,
    Organisation,
    // Pagination,
    InlineSearch,
    User,
  },

  props: {
    organisation: Object,
    users: Array,
    columns: {
      type: Array,
      default: () => [
        {
          title: 'First Name',
          column: 'first_name',
          filter: '',
        },
        {
          title: 'Last Name',
          column: 'last_name',
          filter: '',
        },
        {
          title: 'Email Address',
          column: 'email',
          filter: '',
        },
        {
          title: 'Role',
          column: 'roles',
          filter: '',
        },
      ],
    },
    limit: {
      type: Number,
      default: 1,
    },
  },

  data() {
    const sortOrders = {};
    this.columns.forEach((key) => {
      sortOrders[key.column] = 1;
    });
    return {
      data: this.users.data,
      sortKey: '',
      sortOrders,
      searchQuery: '',
      limitData: this.limit + 10,
      loading: false,
    };
  },

  computed: {
    filteredUsers() {
      const { sortKey } = this;
      const searchQuery = this.searchQuery && this.searchQuery.toLowerCase();
      const order = this.sortOrders[sortKey] || 1;
      let { users } = this;

      if (searchQuery) {
        users = users.filter((user) => user.fullname.toLowerCase().indexOf(searchQuery) > -1);
      }

      if (sortKey) {
        users = users.slice().sort((a, b) => {
          const compA = a[sortKey];
          const compB = b[sortKey];

          // eslint-disable-next-line no-nested-ternary
          return (compA === compB ? 0 : compA > compB ? 1 : -1) * order;
        });
      }
      return users;
    },

    showLoadMore() {
      return this.users.length === this.limit;
    },
  },

  filters: {
    removeUnderscore(str) {
      return str.replace('_', ' ');
    },
  },

  methods: {
    loadMore() {
      this.loading = true;

      const url = this.route('organisation.user.index', [this.organisation.id]);

      this.$inertia.visit(url, {
        method: 'get',
        data: {
          limit: this.limitData,
        },
        replace: false,
        preserveState: false,
        preserveScroll: false,
        only: [],
      });
    },

    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
    },

    userDeleted(id) {
      this.data = this.data.filter((user) => user.id !== id);
    },
  },
};
</script>
